/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { BeeTemplate } from 'cio/data/bee-templates';
import TemplateModel from 'cio/models/template';
import TransactionalMessageModel from 'cio/models/transactional-message';
import { action } from '@ember/object';
import { buildWaiter } from '@ember/test-waiters';

let waiter = buildWaiter('email-choose-template-preview:iframe-load-waiter');

interface ActionComposerEmailChooseTemplatePreviewArgs {
  index: number;
  isSelected: boolean;
  isSelecting: boolean;
  onSelect: () => void;
  onPreview: () => void;
  template: TemplateModel | BeeTemplate;
}

export default class ActionComposerEmailChooseTemplatePreview extends Component<ActionComposerEmailChooseTemplatePreviewArgs> {
  get name() {
    if (this.args.template instanceof BeeTemplate) {
      return this.args.template.name;
    }

    let { template } = this.args;

    if (template.action) {
      return template.action.name;
    } else if (template.newsletter) {
      return template.newsletter.name;
    } else if (template.transactionalMessage) {
      return template.transactionalMessage.name;
    }

    return;
  }

  get body() {
    let { template } = this.args;

    if (template instanceof TemplateModel && template.transactionalMessage instanceof TransactionalMessageModel) {
      return template.transactionalMessage.preview;
    } else {
      return template.body;
    }
  }

  get isBeeTemplate() {
    return this.args.template instanceof BeeTemplate;
  }

  iframe: null | HTMLIFrameElement = null;
  iframeWaiterToken: any = null;

  willDestroy() {
    super.willDestroy();

    if (this.iframe != null) {
      this.iframe.removeEventListener('load', this.onIframeLoad);
    }
  }

  @action
  onInsertIframe(iframe: HTMLIFrameElement) {
    this.iframe = iframe;
    this.iframeWaiterToken = waiter.beginAsync();
    iframe.addEventListener('load', this.onIframeLoad);
  }

  @action
  onIframeLoad() {
    if (this.iframe != null) {
      this.iframe.removeEventListener('load', this.onIframeLoad);
    }

    if (this.iframeWaiterToken != null) {
      waiter.endAsync(this.iframeWaiterToken);
      this.iframeWaiterToken = null;
    }
  }
}
